import { cssVar } from "../../../components/cssInJs";
import * as mobx from "mobx";
import ThemeStore from "../ThemeStore";

/**
 *
 * @param {*} input - a css color string
 * @returns {[number,number,number,number]} an rgba color
 */
function parseColor(input) {
  const div = document.createElement("div");
  div.style.color = input;
  window.document.body.appendChild(div);
  const c = getComputedStyle(div).color;
  window.document.body.removeChild(div);
  // comes back rgb or rgba
  const m = c.match(/[\d|\.]+/g);
  let color = (m || []).map(n => Number(n));
  if (color.length === 3) {
    return color.concat([1]);
  } else if (color.length === 4) {
    return color;
  } else {
    return [255, 255, 255, 1]; // failed. maybe throw error here instead. Defaults to white
  }
}

/**
 *
 * @param {[number, number, number, number]} color1
 * @param {[number, number, number, number]} color2
 * @return {Function} - function that accepts a weight between 0 and 1.
 *                  function will return interpolated color values in rgba space at the specified transition (e.g. 0.5 would be an average)
 */
function interpolate(color1, color2) {
  /**
   * @param {number} - weight between 0 and 1
   */
  return weight => {
    const weight2 = 1 - weight;
    const interpolated = color1.map((c1, i) => {
      const c2 = color2[i];
      return c1 * weight + c2 * weight2;
    });
    return interpolated;
  };
}

/**
 *
 * @param {[number, number, number, number]} array
 * @return {string} - rgba color string
 */
function rgbaString(array) {
  return `rgba(${array.slice(0, 4).join(",")})`;
}

function bootstrapThemeForReactSelect() {
  const primary = cssVar("--primary");
  const bg = cssVar("--input-bg");
  const primaryParsed = parseColor(primary);
  const bgParsed = parseColor(bg);
  const primaryInterpolator = interpolate(primaryParsed, bgParsed);
  return {
    colors: {
      primary: cssVar("--primary"),
      primary75: rgbaString(primaryInterpolator(0.75)),
      primary50: rgbaString(primaryInterpolator(0.5)),
      primary25: rgbaString(primaryInterpolator(0.25)),
      danger: cssVar("--danger"),
      // dangerLight: cssVar("--"),
      neutral0: cssVar("--body-color"),
      neutral5: cssVar("--gray-100"),
      neutral10: cssVar("--gray-200"),
      neutral20: cssVar("--gray-300"),
      neutral30: cssVar("--gray-400"),
      neutral40: cssVar("--gray-500"),
      neutral50: cssVar("--gray-600"),
      neutral60: cssVar("--gray-700"),
      neutral70: cssVar("--gray-800"),
      neutral80: cssVar("--gray-900"),
      neutral90: cssVar("--gray-900")
    }
  };
}

/** cache the react select theme based on the theme store */
let cachedBsThemeVar = null;
ThemeStore.whenModified(() => cachedBsThemeVar = null);

function cachedBsTheme() {
  if (cachedBsThemeVar) {
    return cachedBsThemeVar;
  } else return (cachedBsThemeVar = bootstrapThemeForReactSelect());
}

/** themed style configuration for react-select dropdown library */
export default function reactSelectTheme(theme) {
  const bs = cachedBsTheme();
  return {
    ...theme,
    ...bs,
    colors: {
      ...theme.colors,
      ...bs.colors
    }
  };
}
